import Vue from "vue";
import YOUI from 'yolodtui';
import 'yolodtui/lib/yolodtui.css';

Vue.use(YOUI);